import { of } from "rxjs";

import { fetchCountriesContent } from "store/countriesContent";

export default ({ locale }) => of(fetchCountriesContent({ locale }));
